(function(){
  function text(el){return (el&&el.textContent||'').trim().toLowerCase();}
  function hasChristian(scope){return !!(scope||document).querySelector('a[href*="/collections/christian-rings"]');}
  function makeLike(a){
    var n=a.cloneNode(false);
    n.href='/collections/christian-rings';
    n.textContent='Christian Rings';
    n.removeAttribute('id');
    n.removeAttribute('aria-current');
    return n;
  }
  function insertAfterAnchor(a){
    var container=a.closest('ul, .hdt-sub-menu, .hdt-dropdown-menu, .aydins-mega') || document;
    if(hasChristian(container)) return;
    var li=a.closest('li');
    if(li && li.parentNode){
      var newLi=li.cloneNode(false);
      newLi.appendChild(makeLike(a));
      li.parentNode.insertBefore(newLi, li.nextSibling);
      return;
    }
    a.parentNode && a.parentNode.insertBefore(makeLike(a), a.nextSibling);
  }
  function install(){
    if(hasChristian(document.querySelector('header')||document)) return;
    var anchors=[].slice.call(document.querySelectorAll('header a, .hdt-header a'));
    var preferred=anchors.filter(function(a){return (a.getAttribute('href')||'').includes('/collections/black-wedding-bands') || (text(a)==='best sellers' && a.closest('.aydins-mega'));});
    if(!preferred.length) preferred=anchors.filter(function(a){return text(a)==='best sellers' || (a.getAttribute('href')||'').includes('/collections/best-sellers');});
    preferred.slice(0,3).forEach(insertAfterAnchor);
  }
  install();
  document.addEventListener('DOMContentLoaded',install);
  setTimeout(install,600); setTimeout(install,1800); setTimeout(install,4000);
})();

/* BETA_MOBILE_COOKIE_COMPACT_2026_05_26: compact Shopify Privacy & Compliance banner on mobile only. */
(function(){
  var css = '@media (max-width:767px){'
    + 'body #shopify-pc__banner.shopify-pc__banner__dialog{left:8px!important;right:8px!important;bottom:8px!important;top:auto!important;width:auto!important;max-width:none!important;max-height:38vh!important;padding:12px!important;overflow-y:auto!important;border-radius:12px!important;box-shadow:0 8px 28px rgba(0,0,0,.22)!important;}'
    + 'body #shopify-pc__banner .shopify-pc__banner__wrapper{width:100%!important;max-width:none!important;padding:0!important;gap:8px!important;}'
    + 'body #shopify-pc__banner #shopify-pc__banner__body-title{font-size:15px!important;line-height:1.2!important;margin:0 0 6px!important;}'
    + 'body #shopify-pc__banner .shopify-pc__banner__body p{font-size:11px!important;line-height:1.35!important;margin:0!important;}'
    + 'body #shopify-pc__banner .shopify-pc__banner__btns{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px!important;width:100%!important;margin-top:8px!important;}'
    + 'body #shopify-pc__banner .shopify-pc__banner__btns button{min-height:38px!important;padding:8px 10px!important;font-size:12px!important;line-height:1.2!important;margin:0!important;}'
    + 'body #shopify-pc__banner #shopify-pc__banner__btn-manage-prefs{grid-column:1/-1!important;min-height:30px!important;order:3!important;}'
    + '}';
  function injectStyle(){
    if(!document.getElementById('beta-mobile-cookie-compact-js-style')){
      var style=document.createElement('style');
      style.id='beta-mobile-cookie-compact-js-style';
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);
    }
  }
  function compact(){
    injectStyle();
    if(!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    var b=document.getElementById('shopify-pc__banner');
    if(!b) return;
    b.style.setProperty('left','8px','important');
    b.style.setProperty('right','8px','important');
    b.style.setProperty('bottom','8px','important');
    b.style.setProperty('top','auto','important');
    b.style.setProperty('width','auto','important');
    b.style.setProperty('max-height','38vh','important');
    b.style.setProperty('overflow-y','auto','important');
    b.style.setProperty('padding','12px','important');
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', compact); else compact();
  window.addEventListener('load', compact);
  setTimeout(compact, 500); setTimeout(compact, 1500); setTimeout(compact, 3000);
  new MutationObserver(compact).observe(document.documentElement,{childList:true,subtree:true});
})();


/* BETA_SERVICE_STRIPE_MENU_2026_06_14: add Service Stripe Rings under By Style. */
(function(){
  function text(el){return (el&&el.textContent||'').trim().toLowerCase();}
  function hasService(scope){return !!(scope||document).querySelector('a[href*="/collections/service-stripe-rings"]');}
  function makeLike(a){
    var n=a.cloneNode(false);
    n.href='/collections/service-stripe-rings';
    n.textContent='Service Stripe Rings';
    n.removeAttribute('id');
    n.removeAttribute('aria-current');
    return n;
  }
  function insertAfterAnchor(a){
    var container=a.closest('ul, .hdt-sub-menu, .hdt-dropdown-menu, .aydins-mega') || document;
    if(hasService(container)) return;
    var li=a.closest('li');
    if(li && li.parentNode){
      var newLi=li.cloneNode(false);
      newLi.appendChild(makeLike(a));
      li.parentNode.insertBefore(newLi, li.nextSibling);
      return;
    }
    a.parentNode && a.parentNode.insertBefore(makeLike(a), a.nextSibling);
  }
  function install(){
    var header=document.querySelector('header')||document;
    if(hasService(header)) return;
    var anchors=[].slice.call(document.querySelectorAll('header a, .hdt-header a'));
    var preferred=anchors.filter(function(a){return /\/collections\/patriotic-rings/.test(a.getAttribute('href')||'') || text(a)==='patriotic rings';});
    if(!preferred.length) preferred=anchors.filter(function(a){return /\/collections\/christian-rings/.test(a.getAttribute('href')||'') || text(a)==='christian rings';});
    preferred.slice(0,3).forEach(insertAfterAnchor);
  }
  install();
  document.addEventListener('DOMContentLoaded',install);
  window.addEventListener('load',install);
  setTimeout(install,600); setTimeout(install,1800); setTimeout(install,4000);
  new MutationObserver(install).observe(document.documentElement,{childList:true,subtree:true});
})();


/* BETA_COLLECTION_TOOLBAR_JS_CLEANUP_2026_06_14: remove unlabeled collection grid/list switcher icons. */
(function(){
  function cleanToolbar(){
    document.querySelectorAll('.hdt-control-layout, hdt-view-layout-switch').forEach(function(el){
      el.style.setProperty('display','none','important');
      el.style.setProperty('visibility','hidden','important');
      el.style.setProperty('width','0','important');
      el.style.setProperty('max-width','0','important');
      el.style.setProperty('height','0','important');
      el.style.setProperty('overflow','hidden','important');
      el.setAttribute('aria-hidden','true');
    });
    document.querySelectorAll('.hdt-control-filter').forEach(function(el){
      el.style.setProperty('flex','1 1 50%','important');
      el.style.setProperty('max-width','50%','important');
    });
    document.querySelectorAll('.hdt-control-sort').forEach(function(el){
      el.style.setProperty('flex','1 1 50%','important');
      el.style.setProperty('max-width','50%','important');
      el.style.setProperty('margin-left','auto','important');
      el.style.setProperty('justify-content','flex-end','important');
      el.style.setProperty('text-align','right','important');
    });
  }
  cleanToolbar();
  document.addEventListener('DOMContentLoaded', cleanToolbar);
  window.addEventListener('load', cleanToolbar);
  setTimeout(cleanToolbar, 400); setTimeout(cleanToolbar, 1200); setTimeout(cleanToolbar, 3000);
  new MutationObserver(cleanToolbar).observe(document.documentElement,{childList:true,subtree:true});
})();
